import React from 'react';
import {motion} from 'framer-motion';
import BeltIcon from './BeltIcon';

export default function TechniqueCard({technique,onClick}) {
  const previewDescription=technique.shortDescription || technique.description;

  return (
    <motion.div
      whileHover={{y: -8,scale: 1.02}}
      transition={{type: 'spring',stiffness: 400,damping: 25}}
      className="glass-card rounded-[2rem] overflow-hidden transition-all duration-500 flex flex-col h-full cursor-pointer group"
      onClick={()=> onClick(technique)}
    >
      {technique.image && (
        <div className="bg-white aspect-[5/4] overflow-hidden">
          <img
            src={technique.image}
            alt={technique.spanishName || technique.koreanName}
            loading="lazy"
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}
      <div className="p-7 flex-grow flex flex-col">
        <div className="mb-5">
          <h3 className="text-lg font-black text-white kr-text mb-1 leading-none uppercase tracking-tight group-hover:text-red-500 transition-colors">
            {technique.koreanName}
          </h3>
          <div className="flex flex-col gap-1.5">
            <p className="text-yellow-400 font-bold text-[10px] uppercase tracking-[0.15em]">
              {technique.spanishName}
            </p>
            {technique.meaning && (
              <div className="flex items-center gap-2 mt-1">
                <div className="h-3 w-[2px] bg-red-600 rounded-full" />
                <p className="text-[11px] text-white font-semibold italic leading-none [text-shadow:_0_1px_4px_rgba(0,0,0,0.8)]">
                  {technique.meaning}
                </p>
              </div>
            )}
          </div>
        </div>
        <p className="text-white text-[13px] leading-relaxed line-clamp-2 mb-6 flex-grow font-medium [text-shadow:_0_1px_4px_rgba(0,0,0,0.9)]">
          {previewDescription}
        </p>
        <div className="flex items-center justify-between pt-5 border-t border-white/10">
          <div className="flex items-center gap-3">
            {technique.beltType && (
              <BeltIcon type={technique.beltType} className="w-12 h-4 shadow-md group-hover:scale-105 transition-transform" />
            )}
          </div>
          <div className="text-[10px] font-black uppercase tracking-[0.2em] text-white/40 group-hover:text-red-500 transition-all flex items-center gap-2">
            DETALLES <span className="text-lg leading-none">→</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
}